import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4fd5697e"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "Search",
  ref: "showPanel"
};
var _hoisted_2 = {
  key: 0,
  class: "hot-search"
};
var _hoisted_3 = {
  key: 1,
  class: "search-list"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_input = _resolveComponent("el-input");

  var _component_el_scrollbar = _resolveComponent("el-scrollbar");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 搜索功能 "), _createCommentVNode(" 搜索框 "), _createVNode(_component_el_input, {
    clearable: "",
    modelValue: _ctx.inputValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.inputValue = $event;
    }),
    size: "small",
    placeholder: "搜索",
    "prefix-icon": _ctx.Search,
    onFocus: _ctx.getFocus,
    onInput: _ctx.handleChangeValue
  }, null, 8
  /* PROPS */
  , ["modelValue", "prefix-icon", "onFocus", "onInput"]), _createCommentVNode(" 热搜榜,插槽 "), _ctx.isSearch ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_scrollbar, {
    height: "562px"
  }, {
    default: _withCtx(function () {
      return [_renderSlot(_ctx.$slots, "box1", {}, undefined, true)];
    }),
    _: 3
    /* FORWARDED */

  })])) : _createCommentVNode("v-if", true), _createCommentVNode(" 搜索列表,插槽 "), _ctx.isSuggest ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_scrollbar, {
    height: "562px"
  }, {
    default: _withCtx(function () {
      return [_renderSlot(_ctx.$slots, "box2", {}, undefined, true)];
    }),
    _: 3
    /* FORWARDED */

  })])) : _createCommentVNode("v-if", true)], 512
  /* NEED_PATCH */
  );
}